var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    stroke: "#BFCBDB",
    d: "M6.5 1.13l1.578 3.198 3.53.513L9.053 7.33l.603 3.515L6.5 9.185l-3.157 1.66.603-3.515-2.553-2.49 3.529-.512L6.5 1.13z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStar);
export default __webpack_public_path__ + "static/media/empty-star.b070f324a7b51e4418f4059d69ef7423.svg";
export { ForwardRef as ReactComponent };